export default {
  'not-found': 'Sidan kunde inte hittas',
  'internal-error': 'Kan inte bearbeta begäran',
  'preview-error':
    '<strong>Artikelns slug är inte giltig</strong>.<br/> Kontrollera att slug-fältet är ifyllt och att artikeln har <strong>publicerats</strong> eller <strong>sparats som utkast</strong>.',
  continue: 'Fortsätt navigera',
}
